export default __webpack_public_path__ + "assets/images/nota-fiscal-success888ed38e15cf7374ed6a91860fe4b4b9.png";